import { ProviderArchetype, ServiceLine } from '../types/platform';

export interface ProviderCapabilityProfile {
  archetype: ProviderArchetype;
  label: string;
  defaultServiceLines: ServiceLine[];
  dispatchFocus: string;
}

export const PROVIDER_CAPABILITY_PROFILES: Record<ProviderArchetype, ProviderCapabilityProfile> = {
  PRIVATE_AMBULANCE: {
    archetype: 'PRIVATE_AMBULANCE',
    label: 'Private Ambulance',
    defaultServiceLines: ['URGENT_RESPONSE', 'PATIENT_TRANSPORT', 'MUTUAL_AID'],
    dispatchFocus: 'Rapid assignment and clinical escalation pathways',
  },
  EVENT_MEDICAL: {
    archetype: 'EVENT_MEDICAL',
    label: 'Event Medical',
    defaultServiceLines: ['EVENT_COVER', 'URGENT_RESPONSE', 'WELFARE_SUPPORT'],
    dispatchFocus: 'Venue zoning, response cells, and crowd-density awareness',
  },
  COMMUNITY_TRANSFER: {
    archetype: 'COMMUNITY_TRANSFER',
    label: 'Community Transfer',
    defaultServiceLines: ['PATIENT_TRANSPORT', 'WELFARE_SUPPORT'],
    dispatchFocus: 'Planned and urgent transfer scheduling with turnaround control',
  },
  BLOOD_ORGAN_LOGISTICS: {
    archetype: 'BLOOD_ORGAN_LOGISTICS',
    label: 'Blood and Organ Logistics',
    defaultServiceLines: ['BLOOD_ORGAN_TRANSPORT', 'SECURE_ESCORT'],
    dispatchFocus: 'Chain-of-custody, SLA timing, and critical route continuity',
  },
  HEMS: {
    archetype: 'HEMS',
    label: 'HEMS',
    defaultServiceLines: ['URGENT_RESPONSE', 'MUTUAL_AID'],
    dispatchFocus: 'Critical care tasking with advanced triage and rapid launch workflow',
  },
  MIXED_RESPONSE: {
    archetype: 'MIXED_RESPONSE',
    label: 'Mixed Response Provider',
    defaultServiceLines: [
      'EVENT_COVER',
      'URGENT_RESPONSE',
      'PATIENT_TRANSPORT',
      'MUTUAL_AID',
      'BLOOD_ORGAN_TRANSPORT',
    ],
    dispatchFocus: 'Multi-service balancing across operational and clinical demand',
  },
};

export const serviceLineLabel = (serviceLine: ServiceLine): string => {
  switch (serviceLine) {
    case 'EVENT_COVER':
      return 'Event Cover';
    case 'URGENT_RESPONSE':
      return 'Urgent Response';
    case 'PATIENT_TRANSPORT':
      return 'Patient Transport';
    case 'MUTUAL_AID':
      return 'Mutual Aid';
    case 'BLOOD_ORGAN_TRANSPORT':
      return 'Blood and Organ Transport';
    case 'WELFARE_SUPPORT':
      return 'Welfare Support';
    case 'SECURE_ESCORT':
      return 'Secure Escort';
    default:
      return serviceLine;
  }
};
